import type { UserRole } from '../types'

export const PERMISSIONS = {
  // User Management
  VIEW_USERS: ['admin', 'manager'] as UserRole[],
  CREATE_USERS: ['admin', 'manager'] as UserRole[],
  EDIT_USERS: ['admin', 'manager'] as UserRole[],
  DELETE_USERS: ['admin'] as UserRole[],

  // Ticket Management
  VIEW_TICKETS: ['admin', 'manager', 'employee'] as UserRole[],
  CREATE_TICKETS: ['admin', 'manager', 'employee'] as UserRole[],
  EDIT_TICKETS: ['admin', 'manager'] as UserRole[],
  ASSIGN_TICKETS: ['admin', 'manager'] as UserRole[],
  RESOLVE_TICKETS: ['admin', 'manager', 'employee'] as UserRole[],
  DELETE_TICKETS: ['admin'] as UserRole[],

  // Device Management
  VIEW_DEVICES: ['admin', 'manager', 'employee'] as UserRole[],
  CREATE_DEVICES: ['admin', 'manager'] as UserRole[],
  EDIT_DEVICES: ['admin', 'manager'] as UserRole[],
  ASSIGN_DEVICES: ['admin', 'manager'] as UserRole[],
  DELETE_DEVICES: ['admin'] as UserRole[],

  // Reports and Analytics
  VIEW_REPORTS: ['admin', 'manager'] as UserRole[],
  EXPORT_DATA: ['admin', 'manager'] as UserRole[],

  // Billing
  VIEW_BILLING: ['admin', 'manager'] as UserRole[],

  // System Administration
  MANAGE_SETTINGS: ['admin', 'employee'] as UserRole[],
  VIEW_LOGS: ['admin'] as UserRole[],
  MANAGE_PERMISSIONS: ['admin'] as UserRole[],
} as const

export type PermissionKey = keyof typeof PERMISSIONS
